import { renewPaymentQuote } from '../renew-payment-quote.js';
/** Buy may mount only after its same-attempt uncertainty fence is acknowledged. */
export function createCardMountRecovery(options) {
    let quote = options.quote;
    let needsApproval = false;
    return async (signal, approved) => {
        await options.client.reportPaymentEvent(options.operation.id, options.attemptId, null, signal);
        if (signal.aborted)
            return;
        if (Date.parse(quote.expiresAt) <= Date.now()) {
            await options.reviewFreshQuote(signal, async (fresh) => {
                if (signal.aborted)
                    return;
                quote = fresh;
                needsApproval = true;
                // Fresh financial terms require another explicit Pay approval.
                options.review();
            });
            return;
        }
        if (needsApproval && !approved)
            return;
        if (needsApproval) {
            await renewPaymentQuote(options.client, options.operation, options.attemptId, options.sessionProofId, quote, options.execute, signal);
            return;
        }
        options.execute(quote.signature);
    };
}
